/* eslint-disable eqeqeq */
import React from "react";
import { Col, Row } from "react-bootstrap";
import { Input } from "../../components";
import { images } from "../../config/images";

const RuleCard = React.memo((props: any) => {
  const { ruleNumber } = props;
  const { subject, setSubject, handleDelete, ruleError } = props;

  const handleSubjectChange = (e: any) => {
    setSubject(e.target.value);
  };

  return (
    <div>
      <div className="border rounded-1 sports-field ">
        <form>
          <Row className="align-items-center g-0">
            <Col lg={2}>
              <h4 className="text-center">Rule {ruleNumber}</h4>
            </Col>
            <Col lg={10}>
              <div className="sports-detail">
                <div className="mb-3 text-start">
                  <label htmlFor="subjectrule" className="form-label">
                    Subject of Rule <small className="text-danger">*</small>
                  </label>
                  <Input
                    type="text"
                    placeholder="Enter Subject of Rule"
                    id="subjectrule"
                    name="subjectrule"
                    className="form-control"
                    value={subject}
                    onChange={handleSubjectChange}
                  />
                </div>
              </div>
            </Col>
          </Row>
          {ruleNumber > 1 ? (
            <img
              onClick={() => handleDelete(ruleNumber - 1)}
              src={images.deletesport.default}
              className="delete-sport"
              alt="Delete Sport"
            />
          ) : null}
        </form>
      </div>
      {ruleError != "" && <div className="error-msg">{ruleError}</div>}
    </div>
  );
});
export { RuleCard };
